import { http } from '@/api/index';

export const getTeams = () => {
  return http.get('/teams');
};

export default {
  getTeams,
};
